import { Link } from 'react-router-dom';
import { Diamond } from 'lucide-react';

const NAV_LINKS = [
  { label: 'Home', href: '#', testid: 'footer-link-home' },
  { label: 'Pricing', href: '#', testid: 'footer-link-pricing' },
  { label: 'Guide', href: '#', testid: 'footer-link-guide' },
  {
    label: 'Contact',
    href: 'https://wa.me/916352442321?text=Hi!%20I%20have%20a%20question%20about%20the%20DesignCarat%20STL%20Bundle.',
    testid: 'footer-link-contact',
    external: true,
  },
];

const LEGAL_LINKS = [
  { label: 'Terms of Service', href: '/terms-of-service', testid: 'footer-link-terms', to: '/terms-of-service' },
  { label: 'Privacy Policy', href: '/privacy-policy', testid: 'footer-link-privacy', to: '/privacy-policy' },
  { label: 'Refund Policy', href: '/refund-policy', testid: 'footer-link-refund', to: '/refund-policy' },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer-section"
      className="relative pt-20 pb-10"
      style={{ background: '#FFFFFF', borderTop: '1px solid rgba(0,0,0,0.06)' }}
    >
      <div className="w-full max-w-6xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 mb-16">
          {/* Brand block */}
          <div className="md:col-span-6">
            <div className="flex items-center gap-2 mb-4">
              <Diamond className="w-4 h-4 text-[#FDC3A1]" />
              <span className="font-heading font-bold text-[#111] text-lg">DesignCarat</span>
            </div>
            <p className="font-body text-sm text-[#888] max-w-sm">
              The ultimate 3D design resource for jewelers, makers, and creative professionals.
            </p>
          </div>

          {/* Navigation */}
          <div className="md:col-span-3">
            <span className="font-body text-[10px] uppercase tracking-widest text-[#bbb] font-bold block mb-4">
              Navigation
            </span>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    data-testid={link.testid}
                    {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                    className="font-body text-sm text-[#777] hover:text-[#111] transition-colors"
                    onClick={(e) => {
                      if (link.external) return;
                      if (link.label === 'Pricing') {
                        e.preventDefault();
                        document.querySelector('[data-testid="pricing-section"]')?.scrollIntoView({ behavior: 'smooth' });
                      } else if (link.label === 'Guide') {
                        e.preventDefault();
                        document.querySelector('[data-testid="guide-section"]')?.scrollIntoView({ behavior: 'smooth' });
                      } else if (link.label === 'Home') {
                        e.preventDefault();
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      }
                    }}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div className="md:col-span-3">
            <span className="font-body text-[10px] uppercase tracking-widest text-[#bbb] font-bold block mb-4">
              Legal
            </span>
            <ul className="space-y-3">
              {LEGAL_LINKS.map((link) => (
                <li key={link.label}>
                  {link.to ? (
                    <Link
                      to={link.to}
                      data-testid={link.testid}
                      className="font-body text-sm text-[#777] hover:text-[#111] transition-colors"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      data-testid={link.testid}
                      className="font-body text-sm text-[#777] hover:text-[#111] transition-colors"
                      onClick={(e) => e.preventDefault()}
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom strip */}
        <div
          className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6"
          style={{ borderTop: '1px solid rgba(0,0,0,0.06)' }}
        >
          <span className="font-body text-xs text-[#bbb]" data-testid="footer-copyright">
            &copy; 2025 DesignCarat. All rights reserved.
          </span>
          <span className="font-body text-xs text-[#bbb]">
            Secure Checkout &bull; 100% Safe &amp; Secure &bull; Made in India
          </span>
        </div>
      </div>
    </footer>
  );
}
